import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Webpack = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.016 18.12L12.35 23v-3.8l5.399-2.957 3.266 1.877zm.592-.534V7.38l-3.17 1.821v6.56l3.17 1.824zm-18.682.534L11.59 23v-3.8l-5.398-2.957-3.266 1.877zm-.593-.534V7.38l3.17 1.821v6.56l-3.17 1.824zM2.704 6.72l8.886-5.005v3.674L5.897 8.507l-.043.025-3.15-1.812zm18.534 0L12.35 1.715v3.674l5.693 3.118.043.025 3.15-1.812zM11.59 18.335l-5.327-2.916V9.642l5.326 3.062v5.63zm.76 0l5.326-2.916V9.642l-5.326 3.062v5.63zM6.625 8.973l5.347-2.928 5.347 2.928-5.347 3.075-5.347-3.075z"
  }));
});
Webpack.displayName = 'Webpack';
export var WebpackDimensions = {
  height: 24,
  width: 24
};